import { View } from 'react-native';

//TODO:web implement loading dots web
export const LoadingDots = View;
